import { BOOKS_INTRO_SECTION, BOOKS } from './constants';
import {
  BooksIntroSectionWrapper,
  SectionTitle,
  SectionDescription,
  sectionContentStyles,
  SectionContentHeader,
  AdditionalDescription,
  SectionButtonContainer,
  BookCardContainer,
  BooksIntroSectionContainer,
  BookCardContent,
  BookImage,
  BookContentWrapper,
  BookTitle,
  BookDescription,
  BookLinkButton,
} from './styles';
import { Gapper } from '../../../../../ui/utils';
import CTAButton from '../../../../../ui/ctaButton';

const BooksIntroSection = () => {
  const handleVisitBookstore =
    (link = 'https://instituteofhypnotherapy.com/products_tag/featured-books/') =>
    () => {
      window.open(link, '_blank', 'noopener,noreferrer');
    };

  return (
    <BooksIntroSectionContainer>
      <Gapper gap={20}>
        <BooksIntroSectionWrapper>
          <Gapper gap={54} styles={sectionContentStyles}>
            <SectionTitle>{BOOKS_INTRO_SECTION.title}</SectionTitle>
            <Gapper gap={28}>
              <SectionDescription>{BOOKS_INTRO_SECTION.description_top}</SectionDescription>
              <SectionDescription>{BOOKS_INTRO_SECTION.description_bottom}</SectionDescription>
            </Gapper>
            <Gapper gap={35}>
              <SectionContentHeader>
                {BOOKS_INTRO_SECTION.additionalDescriptionTitle}
              </SectionContentHeader>
              <Gapper gap={25}>
                <AdditionalDescription>
                  {BOOKS_INTRO_SECTION.additionalDescriptionTop}
                </AdditionalDescription>
                <AdditionalDescription>
                  {BOOKS_INTRO_SECTION.additionalDescriptionBottom}
                </AdditionalDescription>
              </Gapper>
              <SectionButtonContainer>
                <CTAButton
                  variant="contained"
                  text={BOOKS_INTRO_SECTION.buttonText}
                  onClick={handleVisitBookstore()}
                />
              </SectionButtonContainer>
            </Gapper>
          </Gapper>
        </BooksIntroSectionWrapper>
        <Gapper gap={20}>
          {BOOKS.map((book, index) => {
            const isEven = index % 2 === 1;

            return (
              <BookCardContainer key={book.title}>
                <BookCardContent isEven={isEven}>
                  <BookImage
                    src={book.image}
                    alt={book.title}
                    loading="lazy"
                    onClick={handleVisitBookstore(book.link)}
                    maxWidth={book.width}
                  />
                  <BookContentWrapper isEven={isEven}>
                    <BookTitle>{book.title}</BookTitle>
                    <BookLinkButton href={book.link} target="_blank" rel="noopener noreferrer">
                      Available on Amazon →
                    </BookLinkButton>
                    <BookDescription>{book.description}</BookDescription>
                  </BookContentWrapper>
                </BookCardContent>
              </BookCardContainer>
            );
          })}
        </Gapper>
      </Gapper>
    </BooksIntroSectionContainer>
  );
};

export default BooksIntroSection;
